
































































import { Component, Prop, Vue, Watch, Emit, Mixins } from 'vue-property-decorator';
import { EventBus, parseFloatNumber, TypeEventBus } from '../utils';
import StatsTravel from './Map/StatsTravel.vue';
import StatsTravelContent from './Map/StatsTravelContent.vue';
import { RootStoreHelper, StoreHelper } from '../../core/mixins';
import { HistoricalParams, HistoricalStats, StatsItems, TypeFilterDate } from '../models';
import { GetterType } from '../../../store';
import { Getter } from 'vuex-class';
import SelectedVehiclesChooser from '../../vehicles/components/SelectedVehiclesChooser.vue';

@Component({
    components: {
        StatsTravel,
        StatsTravelContent,
        SelectedVehiclesChooser
    }
})
export default class ChartLayout extends Mixins(RootStoreHelper, StoreHelper) {
    @Prop({ default: true }) oneChield: boolean;
    @Prop() vehiclesSelected: any;
    @Prop() vehiclesWithHistoricalData: any;
    @Prop() chartOptions: any;
    @Prop() chartVisibility: any;
    @Prop() defaultVehicleSelected: any;
    @Prop() shouldDisplayVehicleSelector: boolean;
    @Prop() expandedPanel: boolean;
    @Prop() isOpen: boolean;
    statsModal: boolean = false;
    statsHeaders: Array<object> = [
        {
            text: 'Vehículo',
            align: 'left',
            value: 'vehicle',
            width: '150px'
        },
        {
            text: 'Variable',
            align: 'left',
            value: 'variable',
            width: '200px'
        },
        {
            text: 'Mínimo',
            align: 'left',
            value: 'min',
            width: '100px',
            formatter: this.parseValues
        },
        {
            text: 'Máximo',
            align: 'left',
            value: 'max',
            width: '100px',
            formatter: this.parseValues
        },
        {
            text: 'Promedio',
            align: 'left',
            value: 'mean',
            width: '130px',
            formatter: this.parseValues
        },
        {
            text: 'Mediana',
            align: 'left',
            value: 'median',
            width: '100px',
            formatter: this.parseValues
        }
    ];
    statsHds: any = [];
    itemsVehicle: any = [];
    vehicles: any = [];
    offsetTop: number = 0;

    @Getter(GetterType.HISTORICAL_DATA_BY_PARAMETERS_STATS_FOR_REFRESH_TABLE)
    $_getHistoricalDataByParametersStatsForRefreshTable: any;


    @Watch('$_getHistoricalDataByParametersStatsForRefreshTable', {deep: true, immediate: true})
    observableStatsChanges(value) {
        this.itemsVehicle = value; 
    }

    @Watch('chartOptions', { immediate: true, deep: true })
    observableChartOptions() {
        if (this.isOpen && this.$_getFilterDate !== TypeFilterDate.TR) {
            this.updateStatsModal();
        }
    }

    onScroll(e) {
        this.offsetTop = e.target.scrollTop;
    }

    get statsTravelModal(): HTMLFormElement {
        return this.$refs.statsTravel as HTMLFormElement;
    }

    get getSelectValue() {
        let value;
        if (this.vehiclesWithHistoricalData.length == 1) {
            value = this.vehiclesWithHistoricalData[0];
        } else {
            value = this.defaultVehicleSelected;
        }
        this.$emit('vehicle-selected-in-chart-layout', value);
        return value;
    }

    @Emit()
    changeVehiclesVariables(vehicleDescription: string) {}

    @Emit()
    updateStats() {}

    @Emit()
    clearVehicleSelector(item) {}

    parseValues(value){
        return parseFloatNumber(value)
    }

    getStatsItems():Array<StatsItems> {
        let items: Array<StatsItems> = [];
        this.vehicles = [];

        if (this.chartOptions && this.chartOptions['series'] && this.chartOptions['series'].length) {
            for (let index = 0; index < this.chartOptions['series'].length; index++) {
                const serie = this.chartOptions['series'][index];
                const vehiclePlate = serie['serie_stats']['vehicle'];
                const data = serie['serie_stats']['data'];
                if (this.vehicles.indexOf(vehiclePlate) == -1) {
                    this.vehicles.push(vehiclePlate);
                }
                if (data) {
                    const variable = serie['serie_stats']['var'];
                    items.push(this.getStatItem(data, variable, vehiclePlate))
                }
            }
            if (this.vehicles.length > 1) {
                items.push(this.getStatItem(this.chartOptions['generalStats'], '', 'Estadísticas generales'))
            }
        }
        return items;
    }

    getStatItem(data: HistoricalStats, variable: string, vehicle: string):StatsItems{
        return {
            variable: variable,
            vehicle: vehicle,
            min: data.min,
            max: data.max,
            mean: data.mean,
            median: data.median
        }
    }

    updateStatsModal() {
        this.itemsVehicle = [];
        this.itemsVehicle = this.getStatsItems();
        if (this.vehicles.length == 1) {
            this.statsHds = this.statsHeaders.filter(item => item['text'] !== 'Vehículo');
        }

        if (this.vehicles.length > 1) {
            this.statsHds = this.statsHeaders.filter(item => item['text'] !== 'Variable');
        }
    }

    showStatsTravel() {
        this.updateStatsModal();
        this.visibilityStatsModal(true);
    }

    visibilityStatsModal(value) {
        this.statsModal = value;
        if (value) this.updateStats();
    }
}
